module.exports = __webpack_public_path__ + "img/041f00f.png";